import Vue from 'vue';
import Api from '../api.js';
import Helpers from './helpers.js';

const onQueueActivityMutation = `
subscription onQueueActivityMutation($authorization: String!) {
  onQueueActivity(authorization: $authorization) {
    body
  } 
}
`;


const queueMemberAddMutation = `
mutation queueMemberAddMutation($queue_id: Int!, $device_id: Int!, $penalty: Int!, $paused: Int!) {
    queueMemberAdd(queue_id: $queue_id, device_id: $device_id, penalty: $penalty, paused: $paused)
}
`;

const queueMemberLeaveMutation = `
mutation queueMemberLeaveMutation($queue_id: Int!, $device_id: Int!) {
    queueMemberLeave(queue_id: $queue_id, device_id: $device_id)
}
`;

const queueMemberPauseMutation = `
mutation queueMemberPauseMutation($queue_id: Int!, $device_id: Int!) {
    queueMemberPause(queue_id: $queue_id, device_id: $device_id)
}
`;

const queueMemberContinueMutation = `
mutation queueMemberContinueMutation($queue_id: Int!, $device_id: Int!) {
    queueMemberContinue(queue_id: $queue_id, device_id: $device_id)
}
`;

const queueTakeCallerMutation = `
mutation queueTakeCallerMutation($channel_id: String!, $device_id: Int!, $unique_id: String!, $queue_name: String!) {
    queueTakeCaller(channel_id: $channel_id, device_id: $device_id, unique_id: $unique_id, queue_name: $queue_name)
}
`;

const queueWhisperMutation = `
mutation queueWhisperMutation($channel_id: String!, $device_id: Int!, $unique_id: String!, $queue_name: String!) {
    agentWhisper(channel_id: $channel_id, device_id: $device_id, unique_id: $unique_id, queue_name: $queue_name)
}
`;

const agentSpyMutation = `
mutation agentSpyMutation($channel_id: String!, $device_id: Int!, $unique_id: String!, $queue_name: String!, $agent_name: String, $connected_line_num: String, $connected_line_name: String) {
    agentSpy(channel_id: $channel_id, device_id: $device_id, unique_id: $unique_id, queue_name: $queue_name, agent_name: $agent_name, connected_line_num: $connected_line_num, connected_line_name: $connected_line_name)
}
`;
const agentBargeMutation = `
mutation agentBargeMutation($channel_id: String!, $device_id: Int!, $unique_id: String!, $queue_name: String!, $agent_name: String, $connected_line_num: String, $connected_line_name: String) {
    agentBarge(channel_id: $channel_id, device_id: $device_id, unique_id: $unique_id, queue_name: $queue_name, agent_name: $agent_name, connected_line_num: $connected_line_num, connected_line_name: $connected_line_name)
}
`;
const agentHangupMutation = `
mutation agentHanupMutation($channel_id: String!, $device_id: Int!, $unique_id: String!, $queue_name: String!) {
    agentHangup(channel_id: $channel_id, device_id: $device_id, unique_id: $unique_id, queue_name: $queue_name)
}
`;

const vuexModule = {
    namespaced: true,
    
    state: {
        // Which session is currently active. 
        queues: [{a:1},{b:2}],
        queue: {},
        channels: [],
        queuesLoading: false,
        queuesSubscription: null,
    },
    getters: {
        currentQueue: (state) => {
            /*
            if (state.conferenceId) {
                for (let i = 0; i < state.conferences.length; i++) {
                    if (state.conferences[i].conference_id === state.conferenceId) {
                        return state.conferences[i];
                    }
                }
            }
            return null;
            */
           return state.conference;
        },
    },
    mutations: {
        queues: (state, val) => {state.queues = val},
        queuesSubscription: (state, val) => {state.queueSubscription = val},
    },
    actions: {
        subscribeToQueues({commit, state, dispatch }) {
            let self = this;
            const subqry = global.gql(onQueueActivityMutation);
            const sub = global.apollo.subscribe({
              query: subqry,
              variables: { authorization: localStorage.getItem('authorizationToken') },
            }).subscribe({
              next (data) {
                // Notify your application with the new arrived data
                //console.log('reveived some sort of data');
                console.log('onQueueActivityMutation!!!!!');
                console.log(data);
                dispatch('processQueueActivity', data);
              },
            });
            commit('queuesSubscription', sub);  
        },
        unsubscribeFromQueues({getters, state}) {
            
            // we stuffed the apollo subscription object inside the conference object
            if (state.queues.queuesSubscription) {
                state.queues.queuesSubscription.unsubscribe();
            }
        },
        processQueueActivity({commit, state, dispatch}, data) {
            console.log('processQueueActivity');
            
            let evt = JSON.parse(data.data.onQueueActivity.body);
            console.log(evt);
            // create a switch statement on data.data.onQueueActivity.body.Event
            
            // javascript switch statement
            switch(evt.Event) {
                case 'AgentConnect':
                    console.log('AgentConnect');
                    for (let i=0; i < state.queues.length; i++) {
                        let stateQ = state.queues[i];
                        if (stateQ.name == evt.Queue) {
                          // update stats 
                          stateQ.Stats.answered++;
                          dispatch('getQueueStats', {queue: stateQ});  
                        }
                    }
                    break;
                case 'QueueCallerJoin':
                    console.log('QueueCallerJoin');
                    for (let i=0; i < state.queues.length; i++) {
                        let stateQ = state.queues[i];
                        if (stateQ.name == evt.Queue) {
                            
                            let timer =  {
                                timePassed: 0,
                                timerId: null,
                                startTimer() {
                                  this.timerId = setInterval(() => {
                                      this.timePassed++;
                                  }, 1000);
                                },
                            };
                            evt.timer = timer;
                            evt.timer.startTimer();
                            evt.menu = false;
                            
                            if (stateQ.callersWaiting) {
                                stateQ.callersWaiting.push(evt);
                            } else {
                                Vue.set(stateQ, 'callersWaiting', [evt]);
                            }

                            // update the stats
                            stateQ.Stats.callers++;
                            // no need to update stats on caller join
                            // as hold times and talk times are not yet known

                        }
                    }
                    break;
                case 'QueueCallerLeave':
                    console.log('QueueCallerLeave');
                    for (let i=0; i < state.queues.length; i++) {
                        let stateQ = state.queues[i];
                        if (stateQ.name == evt.Queue) {
                            for (let j=0; j < stateQ.callersWaiting.length; j++) {
                                if (stateQ.callersWaiting[j].Uniqueid == evt.Uniqueid) {
                                    let caller = stateQ.callersWaiting[j];
                                    clearInterval(caller.timer.timerId);
                                    stateQ.callersWaiting.splice(j, 1);
                                    break;
                                }
                            }
                        }
                    }
                    break;
                case 'QueueCallerAbandon':
                    console.log('QueueCallerAbandon');
                    for (let i=0; i < state.queues.length; i++) {
                        let stateQ = state.queues[i];
                        if (stateQ.name == evt.Queue) {
                            stateQ.callersAbandoned.push(evt);   

                            // update the stats
                            stateQ.Stats.abandoned++;
                            dispatch('getQueueStats', {queue: stateQ});  
                        }
                    }
                    break;
                case 'QueueMemberStatus':
                    console.log('QueueMemberStatus');
                    for (let i=0; i < state.queues.length; i++) {
                        let stateQ = state.queues[i];
                        if (stateQ.name == evt.Queue) {
                            // find the member
                            for (let j=0; j < stateQ.AstQueueDevices.length; j++) {
                                let qd = stateQ.AstQueueDevices[j];
                                console.log('qd.device_name ' + qd.device_name + ' == ' + evt.MemberName)
                                if (qd.device_name.trim() == evt.MemberName.trim()) {
                                    for (let k=0; k < qd.Sipdevices.length; k++) {
                                        let sd = qd.Sipdevices[k];
                                        // get remainder of string after 'PJSIP/'
                                        let pos = evt.Interface.indexOf('/');
                                        let interfaceName = evt.Interface.substring(pos+1);
                                        console.log('interfaceName: ' + interfaceName + ' sd.name: ' + sd.name)
                                        if (sd.name == interfaceName) {
                                            console.log('setting status to ' + evt.Status + ' for ' + sd.name);
                                            Vue.set(sd, 'Status', evt.Status);
                                            Vue.set(sd, 'Ringinuse', evt.Ringinuse);
                                            Vue.set(sd, 'Paused', evt.Paused);
                                            Vue.set(sd, 'PausedReason', evt.PausedReason)
                                            Vue.set(sd, 'InCall', evt.InCall);

                                            if (evt.Status == 1) {
                                                Vue.set(sd, 'StatusText', 'Available');
                                            }
                                        }
                                    }
                                    qd.paused = evt.Paused;
                                    break;
                                }
                            }

                            // update stats
                            dispatch('getQueueStats', {queue: stateQ});
                        }
                    }
                    break;
                case 'QueueMemberAdd':
                    // this is not a real asterisk event
                    // its fired from graphql when a queue member is added
                    for (let i=0; i < state.queues.length; i++) {
                        let stateQ = state.queues[i];
                        if (stateQ.name == evt.Queue) {
                            stateQ.AstQueueDevices.push(evt.Device);
                        }
                    }
                    break;    
                case 'QueueMemberLeave':
                    // this is not a real asterisk event
                    // its fired from graphql when a queue member is added
                    for (let i=0; i < state.queues.length; i++) {
                        let stateQ = state.queues[i];
                        if (stateQ.name == evt.Queue) {
                            for (let j=0; j < stateQ.AstQueueDevices.length; j++) {
                                let qd = stateQ.AstQueueDevices[j];
                                if (qd.device_name == evt.Device.device_name) {
                                    stateQ.AstQueueDevices.splice(j, 1);
                                    break;
                                }
                            }
                        }
                    }
                    break;
                case 'QueueMemberPause':
                    // this is not a real asterisk event
                    // its fired from graphql when a queue member is added
                    for (let i=0; i < state.queues.length; i++) {
                        let stateQ = state.queues[i];
                        if (stateQ.name == evt.Queue) {
                            for (let j=0; j < stateQ.AstQueueDevices.length; j++) {
                                let qd = stateQ.AstQueueDevices[j];
                                if (qd.device_name == evt.Device.device_name) {
                                    for (let k=0; k < qd.Sipdevices.length; k++) {
                                        let sd = qd.Sipdevices[k];
                                        // get remainder of string after 'PJSIP/'
                                        Vue.set(sd, 'Paused', 1);
                                    }
                                }
                            }
                        }
                    }
                    break;
                case 'QueueMemberContinue':
                    // this is not a real asterisk event
                    // its fired from graphql when a queue member is added
                    for (let i=0; i < state.queues.length; i++) {
                        let stateQ = state.queues[i];
                        if (stateQ.name == evt.Queue) {
                            for (let j=0; j < stateQ.AstQueueDevices.length; j++) {
                                let qd = stateQ.AstQueueDevices[j];
                                if (qd.device_name == evt.Device.device_name) {
                                    for (let k=0; k < qd.Sipdevices.length; k++) {
                                        let sd = qd.Sipdevices[k];
                                        // get remainder of string after 'PJSIP/'
                                        Vue.set(sd, 'Paused', 0);
                                    }
                                }
                            }
                        }
                    }
                    break;
                case 'UserEvent':
                    switch (evt.UserEvent) {
                        case 'MemberConnect':
                            console.log('MemberConnect');
                            for (let i=0; i < state.queues.length; i++) {
                                let stateQ = state.queues[i];
                                if (stateQ.name == evt.Queue) {
                                    for (let j=0; j < stateQ.AstQueueDevices.length; j++) {
                                        let qd = stateQ.AstQueueDevices[j];
                                        let deviceId = parseInt(evt.DEVICEID);
                                        if (qd.device_id == deviceId) {
                                            qd.Caller = evt;
                                            Vue.set(qd.Caller,'menu', false);  
                                        }
                                    }
                                }
                            }

                            break;
                        default:
                            console.log('default');
                    }
                    // this is not a real asterisk event
                    // its fired from graphql when a queue member is added
                    
                    break;
                default:   
                    console.log('default');
                    console.log(data.data.onQueueActivity.body);
                    
            }

            
            
        },
        async getQueues({ commit, dispatch, state, rootState }) {
            if (!rootState.user) return;
            if (rootState.user.user_id == 'guest') return;
            state.queuesLoading = true;
            let api = new Api(global.gqlClient());
            let result = await api.myQueues();
            state.queuesLoading = false;
            if (!result) return;

            // add callersWaiting to each queue
            for (let i=0; i < result.data.myQueues.length; i++) {
                let q = result.data.myQueues[i];
                q.callersWaiting = [];
                q.callersAbandoned = [];

                /* I used to set the status and paused to null here
                but now its done in graphql
                for (let j=0; j < q.AstQueueDevices.length; j++) {
                    let qd = q.AstQueueDevices[j];
                    for (let k=0; k< qd.Sipdevices.length; k++) {
                        let sd = qd.Sipdevices[k];
                    }
                }
                */
            }

            // Add Caller to each queue device for responsive display
            for (let i=0; i < result.data.myQueues.length; i++) {
                let q = result.data.myQueues[i];
                for (let j=0; j < q.AstQueueDevices.length; j++) {
                    let qd = q.AstQueueDevices[j];
                    qd.Caller = null;
                }
            }

            // Add blank stats to each queue
            for (let i=0; i < result.data.myQueues.length; i++) {
                let q = result.data.myQueues[i];
                q.Stats = {
                    callers: 0,
                    answered: 0,
                    abandoned: 0,
                    avg_talk_time: 0,
                    avg_hold_time: 0,
                    longest_hold_time: 0,
                    loading: false,
                }
                dispatch('getQueueStats', {queue: q});
            }
            
            console.log(result.data.myQueues);
            commit('queues', result.data.myQueues);
            return true;
        },
        async getQueueStats({ commit, dispatch, state, rootState }, {queue}) {
            console.log('getQueueStats');
            console.log(queue.Stats);
            queue.Stats.loading = true;
            let api = new Api(global.gqlClient());
            let result = await api.queueStats(queue.ast_queue_id);
            queue.Stats.loading = false;
            if (!result) return;
            queue.Stats = result.data.queueStats;
            return true;
        },
        async queueMemberAdd({ commit, dispatch, state, rootState }, {queue, device, penalty, paused}) {
            let variables = {
                queue_id: parseInt(queue.ast_queue_id),
                device_id: parseInt(device.device_id),
                penalty: parseInt(penalty),
                paused: parseInt(paused)
            };
            const gqlClient = global.gqlClient();
            await gqlClient.request(queueMemberAddMutation, variables);
            return 1;
        },
        async queueMemberLeave({ commit, dispatch, state, rootState }, {queue, device}) {
            let variables = {
                queue_id: parseInt(queue.ast_queue_id),
                device_id: parseInt(device.device_id),
            };
            const gqlClient = global.gqlClient();
            await gqlClient.request(queueMemberLeaveMutation, variables);
            return 1;
        },
        async queueMemberPause({ commit, dispatch, state, rootState }, {queue, device}) {
            let variables = {
                queue_id: parseInt(queue.ast_queue_id),
                device_id: parseInt(device.device_id),
            };
            const gqlClient = global.gqlClient();
            await gqlClient.request(queueMemberPauseMutation, variables);
            return 1;
        },
        async queueMemberContinue({ commit, dispatch, state, rootState }, {queue, device}) {
            let variables = {
                queue_id: parseInt(queue.ast_queue_id),
                device_id: parseInt(device.device_id),
            };
            const gqlClient = global.gqlClient();
            await gqlClient.request(queueMemberContinueMutation, variables);
            return 1;
        },
        async takeCaller({ commit, dispatch, state, rootState }, {caller, device}) {
            let variables = {
                channel_id: caller.Channel,
                device_id: parseInt(device.device_id),
                unique_id: caller.Uniqueid,
                queue_name: caller.Queue
            };
            const gqlClient = global.gqlClient();
            await gqlClient.request(queueTakeCallerMutation, variables);
            return 1;
        },
        async whisperToAgent({ commit, dispatch, state, rootState }, {caller, device}) {
            let variables = {
                channel_id: caller.Channel,
                device_id: parseInt(device.device_id),
                unique_id: caller.Uniqueid,
                queue_name: caller.Queue
            };
            const gqlClient = global.gqlClient();
            await gqlClient.request(queueWhisperMutation, variables);
            return 1;
        },
        async agentSpy({ commit, dispatch, state, rootState }, {caller, device, agentDevice}) {
            let variables = {
                channel_id: caller.Channel,
                device_id: parseInt(device.device_id),
                unique_id: caller.Uniqueid,
                queue_name: caller.Queue,
                agent_name: agentDevice.device_name,
                connected_line_num: caller.ConnectedLineNum,
                connected_line_name: caller.ConnectedLineName
            };
            const gqlClient = global.gqlClient();
            await gqlClient.request(agentSpyMutation, variables);
            return 1;
        },
        async agentBarge({ commit, dispatch, state, rootState }, {caller, device, agentDevice}) {
            let variables = {
                channel_id: caller.Channel,
                device_id: parseInt(device.device_id),
                unique_id: caller.Uniqueid,
                queue_name: caller.Queue,
                agent_name: agentDevice.device_name,
                connected_line_num: caller.ConnectedLineNum,
                connected_line_name: caller.ConnectedLineName
            };
            const gqlClient = global.gqlClient();
            await gqlClient.request(agentBargeMutation, variables);
            return 1;
        },
        async agentHangup({ commit, dispatch, state, rootState }, {caller, device}) {
            let variables = {
                channel_id: caller.Channel,
                device_id: parseInt(device.device_id),
                unique_id: caller.Uniqueid,
                queue_name: caller.Queue
            };
            const gqlClient = global.gqlClient();
            await gqlClient.request(agentHangupMutation, variables);
            return 1;
        }
    },
};

export default vuexModule;